// src/pages/quality/QualityView.jsx
import { useParams } from "react-router-dom";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";

// 모바일 전용 뷰 컴포넌트 사용
import MobileQualityMIView from "./components/MobileQualityMIView";
import MobileQualityPCView from "./components/MobileQualityPCView";
import MobileQualityNCView from "./components/MobileQualityNCView";
import MobileQualityCAView from "./components/MobileQualityCAView";

// 🔹 form_type에 따라 실제 뷰를 골라주는 라우터 컴포넌트
function QualityViewRouter({ data, meta, project }) {
  const VIEW_MAP = {
    MI: MobileQualityMIView,
    PC: MobileQualityPCView,
    NC: MobileQualityNCView,
    CA: MobileQualityCAView,
  };

  const formType = (data?.form_type || "").toUpperCase();
  console.log("QUALITY formType:", formType);

  const ViewComp =
    VIEW_MAP[formType] ||
    (() => (
      <div>지원되지 않는 문서 형식입니다 ({formType || "알 수 없음"})</div>
    ));

  // MobileFormViewManager가 넘겨준 data/meta/project를 그대로 전달
  return <ViewComp data={data} meta={meta} project={project} />;
}

export default function QualityView() {
  const { id: projectId, dns } = useParams();

  return (
    <MobileFormViewManager
      params={{
        project: projectId,
        dns,
        module: "quality",
        doc_type: "",
      }}
      doc_name="품질 문서"
    >
      <QualityViewRouter />
    </MobileFormViewManager>
  );
}
